import { Card, CardContent, Grid } from '@mui/material';
import React from 'react';
import { useLogEvent } from '../../../../../../hooks';
import { TypographyEnhanced } from '../../../../../global';
import { LOG_EVENT_PATH, TRANSLATION_PATH } from './constants/defaults';

// TODO add real data in

const RewardOverview = () => {
  useLogEvent(LOG_EVENT_PATH('TAB_VIEWED'));

  return (
    <Card>
      <CardContent>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TypographyEnhanced id={TRANSLATION_PATH('about.title')} variant='h6' />
            <TypographyEnhanced id={TRANSLATION_PATH('about.description')} variant='body1' />
          </Grid>
          <Grid item xs={12}>
            <TypographyEnhanced id={TRANSLATION_PATH('specs.title')} variant='h6' />
          </Grid>
          <Grid item xs={12}>
            <TypographyEnhanced id={TRANSLATION_PATH('preview.title')} variant='h6' />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default RewardOverview;
